import moment from "moment";
let timeStemp = moment()
  .add(543, "years")
  .format("DD/MM/YYYY hh:mm:ss", true);

const print_document = async function(data) {
  let DATA = data;
  for (const key in DATA) {
    //console.log(DATA[key]);
    if (!DATA[key] || DATA[key] == undefined) {
      DATA[key] = "-";
    }
    //console.log(DATA[key]);
  }
  console.log(DATA);
  let newCar_typew = "*",
    newWA = 0,
    newWB = 0,
    newWC = 0;

  DATA.CAR_TYPE = "1"
    ? (newCar_typew = "4 ล้อ")
    : (DATA.CAR_TYPE = "2" ? newCar_typew == "6 ล้อ" : (newCar_typew = "-"));
  // DATA.TD1_WA != "-" ? (newWA += parseInt(DATA.TD1_WA)) : (newWA += 0);
  // DATA.TD2_WA != "-" ? (newWA += parseInt(DATA.TD2_WA)) : (newWA += 0);
  // DATA.TD3_WA != "-" ? (newWA += parseInt(DATA.TD3_WA)) : (newWA += 0);
  // DATA.TD3_WA != "-" ? (newWA += parseInt(DATA.TD3_WA)) : (newWA += 0);

  // DATA.TD4_WB != "-" ? (newWB += parseInt(DATA.TD4_WB)) : (newWB += 0);
  // DATA.TD5_WB != "-" ? (newWB += parseInt(DATA.TD5_WB)) : (newWB += 0);
  // DATA.TD6_WB != "-" ? (newWB += parseInt(DATA.TD6_WB)) : (newWB += 0);
  // DATA.TD7_WB != "-" ? (newWB += parseInt(DATA.TD7_WB)) : (newWB += 0);

  // DATA.TD8_WC != "-" ? (newWC += parseInt(DATA.TD8_WC)) : (newWC += 0);
  // DATA.TD8_WC != "-" ? (newWC += parseInt(DATA.TD8_WC)) : (newWC += 0);

  let newTimeDATAW_I = await newTime(DATA.W_I);
  let newTimeDATAW_O = await newTime(DATA.W_I);
  DATA.W_O = newTimeDATAW_O.b;
  DATA.W_I = newTimeDATAW_I.b;
  DATA.D_D = "-" ? DATA.D_D : (DATA.D_D = await newTimeN(DATA.D_D));
  const pdf = {
    pageSize: 'A4',
    // pageMargins: [ 30, 0, 30, 0 ],
    footer(currentPage, pageCount) {
      return {
        columns: [
          // { text: "ท้ายกระดาษ", fontSize: 15, alignment: "center" },
          {
            text:
              "หน้าที่ " +
              currentPage.toString() +
              " จาก " +
              pageCount +
              " หน้า",
            margin: [5, 5, 15, 5],
            alignment: "right",
          },
        ],
      };
    },
    //สีพื้นหลัง
    // background: function() {
    //   return {
    //     canvas: [
    //       {
    //         type: "rect",
    //         x: 0,
    //         y: 0,
    //         w: 595.28,
    //         h: 841.89,
    //         color: "#00BFFF",
    //       },
    //     ],
    //   };
    // },
    content: [
      {
        columns: [
          {
            text: `เลขที่ :   ${DATA.T_ID}    \n วันที่พิมพ์    ${timeStemp} น.`,
            fontSize: 16,
            alignment: "left",
            // margin: [0, 0, 0, 0],//left top right bottom
          },
          {
            text: `เอกสารกำกับขนส่งมูลฝอยติดเชื้อ ตช.`,
            fontSize: 16,
            bold: true,
            style: `header`,
            margin: [0, 10, 0, 0],
          },
          {
            qr: DATA.rootURL,
            fit: 70,
            alignment: "right",
            margin: [0, 0, 0, 0], //left top right bottom
          },
        ],
      },

      {
        columns: [
          {
            text: `ชื่อเอกชน/ผู้เก็บขน ที่อยู่     ${this.$AppName.CoLtd}`,
            fontSize: 16,
            style: `content`,
          },

          {
            text: `โทรศัพท์     0816949845`,
            fontSize: 16,
            style: `content`,
            width: 200,
          },
        ],
      },
      {
        columns: [
          {
            text: `รถขนมูลฝอย     ${newCar_typew}`,
            fontSize: 16,
            style: `content`,
          },
          {
            text: `เลขทะเบียน     ${DATA.CAR_NUMBER}`,
            fontSize: 16,
            style: `content`,
            width: 200,
          },
        ],
      },
      {
        columns: [
          {
            text: `ชื่อคนขับรถ     ${DATA.PD_NAME} ${DATA.PD_LAST}`,
            fontSize: 16,
            style: `content`,
          },
          {
            text: `โทรศัพท์     ${DATA.PD_PHONE}`,
            fontSize: 16,
            style: `content`,
            width: 200,
          },
        ],
      },
      {
        columns: [
          {
            text: `ชื่อพนักงานเก็บขน     ${DATA.PC_NAME} ${DATA.PC_LAST}`,
            fontSize: 16,
            style: `content`,
          },
          {
            text: `โทรศัพท์     ${DATA.PC_PHONE}`,
            fontSize: 16,
            style: `content`,
            width: 200,
          },
        ],
        margin: [0, 0, 0, 10], //left top right bottom
      },
      // {
      //   text: `ชื่อเอกชน/ผู้เก็บขน ที่อยู่ _________________ โทรศัพท์ _________________ \n รถขนมูลฝอย _________________  เลขทะเบียน _________________ \n ชื่อคนขับรถ _________________  โทรศัพท์ _________________ \n ชื่อพนักงานเก็บขน ________________ โทรศัพท์ ________________ \n `,
      //   style: `content`,
      // },

      {
        table: {
          headerRows: 1,
          widths: [70, "*", 70, 70, 70],
          bodyRows: 2,
          body: [
            [
              {
                text: "วันที่",
                bold: true,
                fontSize: 16,
                alignment: "center",
              },
              {
                text: "แหล่งกำเนิดมูลฝอยติดเชื้อ",
                bold: true,
                fontSize: 16,
                alignment: "center",
              },
              {
                text: "เวลาเข้าเก็บ",
                fontSize: 16,
                bold: true,
                alignment: "center",
              },
              {
                text: "เวลาออก",
                fontSize: 16,
                bold: true,
                alignment: "center",
              },
              {
                text: "ปริมาณมูลฝอย (กก.)",
                fontSize: 16,
                bold: true,
                alignment: "center",
              },
            ],
            [
              {
                text: `${newTimeDATAW_I.a}`,
                fontSize: 16,
                alignment: "center",
                justify: "center",
              },
              {
                text: DATA.C_N,
                fontSize: 16,
                alignment: "center",
                justify: "center",
              },
              {
                text: `${DATA.W_I} น.`,
                fontSize: 16,
                alignment: "center",
                justify: "center",
              },
              {
                text: `${DATA.W_O} น.`,
                fontSize: 16,
                alignment: "center",
                justify: "center",
              },
              {
                text: DATA.W_W,
                fontSize: 16,
                alignment: "center",
                justify: "center",
              },
            ],
          ],
        },
      },
      {
        columns: [
          {
            text: `ชื่อ จนท.รพ. ผู้ส่งมอบมูลฝอย   ................................`,
            style: `content`,
            fontSize: 16,
            margin: [15, 15, 0, 0], //left top right bottom
          },
          {
            text: "ลายเซ็น",
            width: 40,
            fontSize: 16,
            style: `content`,
            margin: [5, 15, 0, 0],
          },
          {
            image: await getBase64ImageFromURL(DATA.urlO),
            width: 50,
            margin: [1, 15, 0, 0],
            alignment: "start",
          },
        ],
      },
      {
        text: `______________________________________________________________________________________`,
        style: `content`,
        fontSize: 16,
        margin: [0, 0, 0, 0], //left top right bottom
      },
      {
        columns: [
          {
            text: `สถานที่กำจัด      ${DATA.D_N}`,
            style: `content`,
            fontSize: 16,
          },
          {
            text: `โทรศัพท์      ${DATA.D_P}`,
            style: `content`,
            fontSize: 16,
            width: 200,
          },
        ],
      },
      {
        columns: [
          {
            text: `ที่อยู่      ${DATA.D_A}`,
            style: `content`,
            fontSize: 16,
          },
        ],
      },
      {
        columns: [
          {
            text: `ชื่อเจ้าหน้าที่โรงกำจัด      ${DATA.D_O}`,
            style: `content`,
            fontSize: 16,
          },
          {
            text: "ลายเซ็น",
            width: 40,
            fontSize: 16,
            style: `content`,
          },
          {
           
            image: await getBase64ImageFromURL(DATA.urlR),
            width: 50,
            alignment: "start",
          },
          {
            text: `โทรศัพท์      ${DATA.D_O_P}`,
            style: `content`,
            fontSize: 16,
            width: 200,
          },
        ],
      },
      {
        columns: [
          // {
          //   text: `ปริมาณกำจัดมูลฝอยสุทธิ      ${DATA.D_W} กก.`,
          //   style: `content`,
          //   fontSize: 16,
          // },
          {
            text: `ว.ด.ป ที่รับมอบ      ${DATA.D_D} น.`,
            style: `content`,
            fontSize: 16,
            width: 200,
          },
        ],
      },
      // {
      //   text: `สถานที่กำจัด __________________________________  โทรศัพท์ _______________ \n ที่อยู่ __________________________________  \n ชื่อเจ้าหน้าที่โรงกำจัด __________________________________  โทรศัพท์ _______________ \n ปริมาณกำจัดมูลฝอยสุทธิ __________________________________  ว.ด.ป ที่รับมอบ _______________ `,
      //   style: `content`,
      // },
      {
        text: `______________________________________________________________________________________`,
        style: `content`,
        margin: [0, 5, 0, 0], //left top right bottom
      },
    ],
    defaultStyle: {
      font: "THSarabunNew",
    },
    styles: {
      header: {
        fontSize: 18,
        alignment: "center",
        //bold: true
      },
      content: {
        fontSize: 16,
        alignment: "left",
        margin: [0, 10, 0, 0],
      },
      content_8: {
        fontSize: 16,
        alignment: "left",
        margin: [20, 10, 0, 0],
      },
      signature: {
        fontSize: 16,
        alignment: "center",
        margin: [0, 30, 0, 0],
      },
    },
  };
  return pdf;
};

function getBase64ImageFromURL(url) {
  return new Promise((resolve, reject) => {
    var img = new Image();
    img.setAttribute("crossOrigin", "anonymous");

    img.onload = () => {
      var canvas = document.createElement("canvas");
      canvas.width = img.width;
      canvas.height = img.height;

      var ctx = canvas.getContext("2d");
      ctx.drawImage(img, 0, 0);

      var dataURL = canvas.toDataURL("image/png");

      resolve(dataURL);
    };

    img.onerror = (error) => {
      reject(error);
    };
    
    img.src = url;
    
  });
}
// The "callback" argument is called with either true or false
// // depending on whether the image at "url" exists or not.
// function imageExists(url, callback) {
//   var img = new Image();
//   img.onload = function() { callback(true); };
//   img.onerror = function() { callback(false); };
//   img.src = url;
// }

// // Sample usage
// var imageUrl = 'http://www.google.com/images/srpr/nav_logo14.png';
// imageExists(imageUrl, function(exists) {
//   console.log('RESULT: url=' + imageUrl + ', exists=' + exists);
// });

// create function TH time
async function newDates(data) {
  // console.log(data);
  let a = moment(data)
    .add(543, "years")
    .format("DD/MM/YYYY hh:mm:ss", true);
  return a;
}
async function newTime(data) {
  //console.log(data);
  let newTime = { a: "", b: "" };
  newTime.a = moment(data)
    .add(543, "years")
    .format("DD/MM/YYYY");
  newTime.b = moment(data).format("hh:mm:ss", true);
  //console.log(newTime);
  return newTime;
}
async function newTimeN(data) {
  let a = moment(data)
    .add(543, "years")
    .format("DD/MM/YYYY hh:mm:ss", true);
  return a;
}

export default print_document;
